import { Form, FormInstance } from "antd";
import { CustomModal } from "../../../../../../../../lib/CustomModal";
import { useCallback, useMemo } from "react";
import { FormContainer } from "./components/FormContainer";
import { IPrimaryData } from "../../../HeaderActions/types/PrimaryData";
import { TPrintData } from "../../types";

type PrintModalProps = {
  contractId: string;
  itemToPrint: TPrintData;
  primaryData: IPrimaryData;
  close: () => void;
};

export const PrintModal = ({
  contractId,
  itemToPrint,
  primaryData,
  close,
}: PrintModalProps) => {
  const [form]: FormInstance[] = Form.useForm();

  const closeModal = useCallback(() => {
    close();
    form.resetFields();
  }, [close, form]);

  const shouldOpen: boolean = useMemo(() => !!itemToPrint, [itemToPrint]);

  return (
    <CustomModal
      isModalOpen={shouldOpen}
      setIsModalOpen={closeModal}
      width={600}
      titleText="Print Letter: Payoff Quote"
      headerClass="processing-print-modal--header"
      modalClass="letter-modal"
      destroyOnClose
    >
      <FormContainer
        contractId={contractId}
        form={form}
        primaryData={primaryData}
        itemToPrint={itemToPrint}
        close={closeModal}
      />
    </CustomModal>
  );
};
